var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUniqueDevices = function SvgUniqueDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19821_41788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 19H3C2.448 19 2 18.552 2 18V17C2 16.448 2.448 16 3 16H13.875",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5C20 3.895 19.105 3 18 3H5C3.895 3 3 3.895 3 5V16",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.875 8H20C21.105 8 22 8.895 22 10V19C22 20.105 21.105 21 20 21H15.875C14.77 21 13.875 20.105 13.875 19V10C13.875 8.895 14.77 8 15.875 8Z",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8V5",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0586 18.75H18.8086",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19821_41788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgUniqueDevices as ReactComponent };
export default __webpack_public_path__ + "unique-devices.svg";